var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"participationRate",attrs:{"id":_vm.Id}})
}
var staticRenderFns = []

export { render, staticRenderFns }